module.exports = __webpack_public_path__ + "assets/img/ability21.5aab9852.png";